module.exports = __webpack_public_path__ + "static/media/thumbnail.38b005ac.jpg";